'use strict';

var getPolyfill = require('./polyfill');

var define = require('define-properties');

module.exports = function shimGetOwnPropertyDescriptors() {
  var polyfill = getPolyfill();
  define(Object, {
    getOwnPropertyDescriptors: polyfill
  }, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors() {
      return Object.getOwnPropertyDescriptors !== polyfill;
    }
  });
  return polyfill;
};